import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'

class DownloadReportModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
    extraColumns: PropTypes.object
  }

  static defaultProps = {
    extraColumns: {}
  }

  constructor(props) {
    super(props)
    this.state = {
      format: 'pdf',
      selectedColumns: [],
      selectedExtraColumns: []
    }
    this.baseColumns = [
      { value: 'weld_type', label: 'Weld Type' },
      { value: 'thickness_1', label: 'Thickness 1' },
      { value: 'diameter_1', label: 'Diameter 1' },
      { value: 'thickness_2', label: 'Thickness 2' },
      { value: 'diameter_2', label: 'Diameter 2' },
      { value: 'material_1', label: 'Material 1' },
      { value: 'material_2', label: 'Material 2' }
    ]
  }

  handleFormatChange = (e) => {
    this.setState({ format: e.target.value })
  }

  handleColumnToggle = (column) => {
    this.setState(prev => ({
      selectedColumns: prev.selectedColumns.includes(column)
        ? prev.selectedColumns.filter(c => c !== column)
        : [...prev.selectedColumns, column]
    }))
  }

  handleExtraColumnToggle = (column) => {
    this.setState(prev => ({
      selectedExtraColumns: prev.selectedExtraColumns.includes(column)
        ? prev.selectedExtraColumns.filter(c => c !== column)
        : [...prev.selectedExtraColumns, column]
    }))
  }

  handleDownload = () => {
    const { format, selectedColumns, selectedExtraColumns } = this.state
    this.props.onDownload(format, selectedColumns, selectedExtraColumns)
    this.props.toggle()
  }

  render() {
    const { isOpen, toggle, extraColumns } = this.props
    const { format, selectedColumns, selectedExtraColumns } = this.state

    let extraColumnsArray = []
    if (extraColumns && typeof extraColumns === 'object') {
      extraColumnsArray = Object.entries(extraColumns).map(([key, value]) => ({
        value: key,
        label: value
      }))
    } else if (extraColumns && typeof extraColumns === 'string') {
      try {
        const parsed = JSON.parse(extraColumns)
        extraColumnsArray = Object.entries(parsed).map(([key, value]) => ({
          value: key,
          label: value
        }))
      } catch (e) {
        extraColumnsArray = []
      }
    }

    const allItems = [
      ...this.baseColumns,
      ...extraColumnsArray
    ]

    const itemsPerColumn = Math.ceil(allItems.length / 3)
    const column1 = allItems.slice(0, itemsPerColumn)
    const column2 = allItems.slice(itemsPerColumn, itemsPerColumn * 2)
    const column3 = allItems.slice(itemsPerColumn * 2)

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Download Report</ModalHeader>
        <ModalBody>
          <FormGroup tag="fieldset">
            <Label>Format</Label>
            <Row>
              <Col md="4">
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="format"
                      value="pdf"
                      checked={format === 'pdf'}
                      onChange={this.handleFormatChange}
                    />
                    {' '}PDF
                  </Label>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup check>
                  <Label check>
                    <Input
                      type="radio"
                      name="format"
                      value="excel"
                      checked={format === 'excel'}
                      onChange={this.handleFormatChange}
                    />
                    {' '}Excel
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </FormGroup>

          <FormGroup>
            <Label>Select columns</Label>
            <Row>
              <Col md="4">
                {column1.map(col => {
                  const isExtra = extraColumnsArray.some(ec => ec.value === col.value)
                  const isSelected = isExtra 
                    ? selectedExtraColumns.includes(col.value)
                    : selectedColumns.includes(col.value)
                  return (
                    <FormGroup check key={col.value}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => isExtra ? this.handleExtraColumnToggle(col.value) : this.handleColumnToggle(col.value)}
                        />
                        {' '}{col.label}
                      </Label>
                    </FormGroup>
                  )
                })}
              </Col>
              <Col md="4">
                {column2.map(col => {
                  const isExtra = extraColumnsArray.some(ec => ec.value === col.value)
                  const isSelected = isExtra 
                    ? selectedExtraColumns.includes(col.value)
                    : selectedColumns.includes(col.value)
                  return (
                    <FormGroup check key={col.value}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => isExtra ? this.handleExtraColumnToggle(col.value) : this.handleColumnToggle(col.value)}
                        />
                        {' '}{col.label}
                      </Label>
                    </FormGroup>
                  )
                })}
              </Col>
              <Col md="4">
                {column3.map(col => {
                  const isExtra = extraColumnsArray.some(ec => ec.value === col.value)
                  const isSelected = isExtra 
                    ? selectedExtraColumns.includes(col.value)
                    : selectedColumns.includes(col.value)
                  return (
                    <FormGroup check key={col.value}>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => isExtra ? this.handleExtraColumnToggle(col.value) : this.handleColumnToggle(col.value)}
                        />
                        {' '}{col.label}
                      </Label>
                    </FormGroup>
                  )
                })}
              </Col>
            </Row>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" onClick={this.handleDownload}>Download</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default DownloadReportModal



// WEBPACK FOOTER //
// ./src/components/Report/DownloadReportModal.js